import axios from 'axios'

export default function (context) {
    if (context.state.dataUploaded) return;
    context.state.load = true;
    context.state.dataUploaded = true;
    axios({
        method: 'post',
        url: '/tourclient/masterAgent/dictionary/user/list',
        data: {
            request: JSON.stringify({}),
            removeZero: true,
        }
    }).then(r => {
        if (r.data.ResultQueryInfo.HasError) {
            context.dispatch('error', {status: r.status, text: r.data.ResultQueryInfo.UserMessages}, {root: true});
            return;
        }
        r.data.Items.forEach(item => {
            item.value = item.Id;
            item.label = item.Name +" "+ item.FirstName;
            context.commit('add', item);
        });
        context.state.load = false;
    }).catch(e => {
        context.dispatch('error', e, {root: true});
    });
}